// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Error_wrapper__2iPMx","box":"Error_box__T7swd"};